export const ACCEPTED_FILE_TYPES = {
  "image/jpeg": [".jpeg", ".jpg"],
  "application/pdf": [".pdf"],
  "application/xml": [".xml"],
  "image/png": [".png"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "text/csv": [".csv"],
  "text/plain": [".txt"],
  "image/gif": [".gif"],
  "image/bmp": [".bmp"],
  "application/vnd.oasis.opendocument.presentation": [".odp"],
  "application/vnd.oasis.opendocument.spreadsheet": [".ods"],
  "application/vnd.oasis.opendocument.text": [".odt"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
  "image/svg+xml": [".svg"],
  "application/vnd.visio": [".vsd"],
};
export const ACCEPTED_IMAGE_TYPES = {
  "image/*": [".jpeg", ".jpg", ".png", ".svg"],
};
